export const spouseIds = (person) => [...new Set(person.spouse_ids ?? (person.spouse_id ? [person.spouse_id] : []))];
